import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { media, customMinResponsive, size } from 'components/styles';

const GradientBg = styled.div<{ isPacket?: boolean; color?: string }>`
	position: absolute;
	inset: 0;
	width: 100%;
	aspect-ratio: 16 / 9;
	${media.min.min(css`
		height: 100%;
		aspect-ratio: unset;
	`)}
	overflow: hidden;

	${({ isPacket }) =>
		!isPacket &&
		css`
			z-index: 2;
		`}

	&:before,
	&:after {
		display: block;
		content: '';
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
	}

	&:before {
		background: ${({ theme }) =>
			`linear-gradient(0deg, ${theme.palette.background.body} 5.79%, ${rgba(theme.palette.background.body, 0.8)} 52.06%, transparent 103.39%)`};

		${customMinResponsive(
			size.semi,
			css`
				background: ${({ theme }) => `linear-gradient(89deg, ${theme.palette.background.body} 16.46%, transparent 70.61%),
				linear-gradient(0deg, ${theme.palette.background.body} 5.79%, ${rgba(theme.palette.background.body, 0.8)} 30.19%, transparent 103.39%)`};
			`
		)}
	}
`;

export default GradientBg;
